import React from 'react';

const menuIcons = {
  card: (
    <svg
      width='15'
      height='14'
      viewBox='0 0 15 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.4259 9.09717H10.7271C9.73611 9.09656 8.93289 8.29395 8.93228 7.30299C8.93228 6.31202 9.73611 5.50941 10.7271 5.5088H13.4259'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.1651 1.5H9.92738C11.8595 1.5 13.4258 3.06634 13.4258 4.99844V9.78313C13.4258 11.7152 11.8595 13.2816 9.92738 13.2816H4.1651C2.233 13.2816 0.666656 11.7152 0.666656 9.78313V4.99844C0.666656 3.06634 2.233 1.5 4.1651 1.5Z'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.6904 4.52544H7.2897'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  password: (
    <svg
      width='12'
      height='14'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.94946 2.70801C8.53812 1.52001 7.40946 0.666681 6.08146 0.666681C4.40612 0.660014 3.04212 2.01201 3.03479 3.68735V3.70068V5.13201'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.622 13.0003H3.528C2.132 13.0003 1 11.8683 1 10.4716V7.61294C1 6.21627 2.132 5.08427 3.528 5.08427H8.622C10.018 5.08427 11.15 6.21627 11.15 7.61294V10.4716C11.15 11.8683 10.018 13.0003 8.622 13.0003Z'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.07503 8.30174V9.78308'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  weekend: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      fill='none'
      viewBox="0 0 14 15"
    >
      <path fill="#d5d5d5"
        d="M13.61 2.46a1.03 1.03 0 0 0-.76-.32h-1.07v-.8c0-.37-.13-.68-.39-.95a1.3 1.3 0 0 0-.95-.39h-.53c-.37 0-.68.13-.95.39-.26.27-.39.58-.39.95v.8H5.36v-.8c0-.37-.13-.68-.4-.95A1.28 1.28 0 0 0 4.02 0h-.54c-.37 0-.68.13-.94.39-.27.27-.4.58-.4.95v.8H1.07c-.29 0-.54.11-.75.32-.21.21-.32.46-.32.75v10.72c0 .29.11.54.32.75.21.21.46.32.75.32h11.78c.29 0 .55-.11.76-.32.21-.21.32-.46.32-.75V3.21c0-.29-.11-.54-.32-.75zM9.64 1.34c0-.08.03-.14.08-.19a.26.26 0 0 1 .19-.08h.53c.08 0 .15.03.2.08.05.05.07.11.07.19v2.41c0 .08-.02.14-.07.19a.28.28 0 0 1-.2.08h-.53a.26.26 0 0 1-.19-.08.26.26 0 0 1-.08-.19zm-6.43 0c0-.08.03-.14.08-.19a.26.26 0 0 1 .19-.08h.54c.08 0 .14.03.19.08.05.05.08.11.08.19v2.41c0 .08-.03.14-.08.19a.26.26 0 0 1-.19.08h-.54a.26.26 0 0 1-.19-.08.26.26 0 0 1-.08-.19zM1.07 13.93V5.36h11.78v8.57z" />
        d="M13.61 2.46a1.03 1.03 0 0 0-.76-.32h-1.07v-.8c0-.37-.13-.68-.39-.95a1.3 1.3 0 0 0-.95-.39h-.53c-.37 0-.68.13-.95.39-.26.27-.39.58-.39.95v.8H5.36v-.8c0-.37-.13-.68-.4-.95A1.28 1.28 0 0 0 4.02 0h-.54c-.37 0-.68.13-.94.39-.27.27-.4.58-.4.95v.8H1.07c-.29 0-.54.11-.75.32-.21.21-.32.46-.32.75v10.72c0 .29.11.54.32.75.21.21.46.32.75.32h11.78c.29 0 .55-.11.76-.32.21-.21.32-.46.32-.75V3.21c0-.29-.11-.54-.32-.75zM9.64 1.34c0-.08.03-.14.08-.19a.26.26 0 0 1 .19-.08h.53c.08 0 .15.03.2.08.05.05.07.11.07.19v2.41c0 .08-.02.14-.07.19a.28.28 0 0 1-.2.08h-.53a.26.26 0 0 1-.19-.08.26.26 0 0 1-.08-.19zm-6.43 0c0-.08.03-.14.08-.19a.26.26 0 0 1 .19-.08h.54c.08 0 .14.03.19.08.05.05.08.11.08.19v2.41c0 .08-.03.14-.08.19a.26.26 0 0 1-.19.08h-.54a.26.26 0 0 1-.19-.08.26.26 0 0 1-.08-.19zM1.07 13.93V5.36h11.78v8.57z" />
    </svg>
  ),
  proxy: (
    <svg
      width='15'
      height='14'
      viewBox='0 0 25 14'
      fill='none'
    >
      <path fill='#898492'
        d='M20.7 3.42a12.88 12.88 0 0 0-17.48 0L0 6.46l3.3 3.12A12.68 12.68 0 0 0 12.04 13c3.17 0 6.33-1.14 8.74-3.42L24 6.54zm-.49 5.62a12.04 12.04 0 0 1-16.34 0L1.15 6.46l2.64-2.5a12.04 12.04 0 0 1 16.34 0l2.72 2.58z' />
        d='M20.7 3.42a12.88 12.88 0 0 0-17.48 0L0 6.46l3.3 3.12A12.68 12.68 0 0 0 12.04 13c3.17 0 6.33-1.14 8.74-3.42L24 6.54zm-.49 5.62a12.04 12.04 0 0 1-16.34 0L1.15 6.46l2.64-2.5a12.04 12.04 0 0 1 16.34 0l2.72 2.58z' />
      <path fill='#898492'
        d='M12.5 2a4.5 4.5 0 1 0 .01 9.01A4.5 4.5 0 0 0 12.5 2zm0 8a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z' />
        d='M12.5 2a4.5 4.5 0 1 0 .01 9.01A4.5 4.5 0 0 0 12.5 2zm0 8a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z' />
    </svg>
  ),
  pencil: (
    <svg
      className='icon icon-pencil-black'
      id='icon-pencil'
      viewBox='0 0 15 15'
      width='100%'
      height='100%'
    >
      <path
        d='M8.71 2.34l2.84 2.86-7.21 7.24L1.5 9.58zm5 .69L12.3 4.45 9.45 1.59 10.66.37c.5-.49 1.29-.49 1.78 0l1.27 1.28c.39.38.39 1 0 1.38zM.01 13.6c-.05.24.16.45.39.39l3.17-.77-2.84-2.86z' />
    </svg>
  ),
  cancel: (
    <svg
      className='icon icon-cancel'
      id='icon-cancel'
      viewBox='0 0 15.5 15.5'
      width='100%'
      height='100%'
    >
      <path
        d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z' />
      <path
        strokeMiterlimit='50'
        strokeWidth='.5'
        d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z'
      />
    </svg>
  ),
  check: (
    <svg
      height="100%"
      width="100%"
      id="Capa_1"
      viewBox="0 0 14 14">
      <path d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27 c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0 L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z" />
    </svg>
  ),
  close: (
    <svg 
    fill="#000000" 
    width="20px"
    height="20px"
    version="1.1" 
    id="Layer_1"
    viewBox="0 0 1792 1792"
    >
      <path d="M1082.2,896.6l410.2-410c51.5-51.5,51.5-134.6,0-186.1s-134.6-51.5-186.1,0l-410.2,410L486,300.4
	c-51.5-51.5-134.6-51.5-186.1,0s-51.5,134.6,0,186.1l410.2,410l-410.2,410c-51.5,51.5-51.5,134.6,0,186.1
	c51.6,51.5,135,51.5,186.1,0l410.2-410l410.2,410c51.5,51.5,134.6,51.5,186.1,0c51.1-51.5,51.1-134.6-0.5-186.2L1082.2,896.6z"/>
    </svg>
  )
};

export function getMenuIcon(type) {
  return menuIcons[type];
}
